import { memo } from 'react';
import { Paper, Stack, IconButton } from '@mui/material';
import DialogTextField from 'components/dialog/DialogTextField';
import { ISurveyTypeProps } from 'interface/project/projectInfo';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import useProjectInfoProvider from 'hooks/useProjectInfoProvider';

function SurveySA({ type, sort, component, handleRemove }: ISurveyTypeProps): JSX.Element {
  const { inputs, dcInputs, dispatch } = useProjectInfoProvider();
  const conditionInputs = type === 'inputs' ? inputs : dcInputs;
  const { stepper3 } = conditionInputs;
  const { questions } = stepper3;

  const handleQuestionChange = (value: string) => {
    dispatch({
      type: 'handleQuestion',
      payload: {
        type,
        questionId: component.questionId,
        question: value,
        actionType: 'update',
      },
    });
  };

  return (
    <Paper elevation={5} sx={{ p: 2, m: 2, display: 'flex', justifyContent: 'flex-start' }}>
      <Stack direction="column" spacing={2} sx={{ width: '100%' }}>
        <DialogTextField
          label={`Q${sort + 1}`}
          labelWidth={40}
          text={questions[sort]?.question || ''}
          variant="outlined"
          name="content"
          onChange={e => handleQuestionChange(e.target.value)}
        />
        <DialogTextField
          label="A"
          labelWidth={40}
          labelSx={{ textAlign: 'right' }}
          text=""
          variant="outlined"
          fullWidth
          disabled
          placeholder="답변 입력칸(입력 불가)"
        />
        <Stack direction="row" justifyContent="flex-end">
          <IconButton onClick={() => handleRemove(component.questionId || '')} sx={{ color: 'error.main', width: 32 }}>
            <RemoveCircleOutlineIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}

export default memo(SurveySA);
